<template>
  <div class="main-container">
    <span class="d-flex ml-4 my-4 py-4">
      <span>
        <span>
          <h4>Wybierz kategorię</h4>
          <select v-model="serviceCategory" required class="form-control mb-4">
            <option disabled :value="null">Wybierz kategorię</option>
            <option
              :value="serviceCategory.id"
              v-for="serviceCategory in serviceCategoriesWithServices"
              :key="serviceCategory.id"
            >
              {{ serviceCategory.name }}
            </option>
          </select>
        </span>

        <span
          v-if="serviceCategory && subCategories && subCategories.length > 0"
        >
          <h4>Wybierz podkategorię</h4>
          <select v-model="subCategory" class="form-control">
            <option disabled :value="null">Wybierz podkategorię</option>
            <option
              :value="subCategory.id"
              v-for="subCategory in subCategories"
              :key="subCategory.id"
            >
              {{ subCategory.name }}
            </option>
          </select>
        </span>
      </span>

      <div>
        <div>
          <div class="d-flex">
            <button
              class="btn btn-outline-dark"
              style="height: 28px; margin-right: 3rem; margin-left: 5rem"
              @click="addingNewCategory = !addingNewCategory"
            >
              {{
                addingNewCategory
                  ? `Zamknij nową kategorię`
                  : `Dodaj nową kategorię`
              }}
            </button>
            <div v-if="addingNewCategory">
              <form
                @submit.prevent="addNewCategory()"
                style="text-align: center"
              >
                <h4>Nowa kategoria</h4>

                <span>
                  <select
                    v-model="serviceType"
                    required
                    class="form-control mb-2 ml-2 mt-4"
                  >
                    <option disabled :value="null">Wybierz typ</option>
                    <option
                      :value="type"
                      v-for="type in serviceCategoriesTypes"
                      :key="type"
                    >
                      {{ type }}
                    </option>
                  </select>
                </span>
                <div>
                  <input
                    v-model="newCategory"
                    id="name_category"
                    class="form-control newCategoryInput"
                    type="text"
                    required
                    minlength="1"
                    placeholder="Nazwa nowej kategorii"
                  />
                </div>
                <div>
                  <input
                    v-model="newCategoryDisplayName"
                    id="display_name_category"
                    class="form-control newCategoryInput"
                    type="text"
                    required
                    minlength="1"
                    placeholder="Nazwa wyświetlana kategorii"
                  />
                </div>
                <div>
                  <html-editor
                    @contentchanged="handleHtmlEditorContentForCategory($event)"
                    :startContent="newCategoryDesription"
                  />
                </div>

                <div>
                  <button
                    type="submit"
                    class="btn btn-outline-dark"
                    style="margin-top: 5px; width: 300px"
                  >
                    Dodaj nową
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </span>
    <form class="topform" @submit="handleServiceCreate($event)">
      <div class="multiple-inputs">
        <div class="input-container">
          <label>Nazwa usługi (np. TEST_CARE):</label>
          <input
            v-model="name"
            id="name"
            class="form-control"
            type="text"
            required
            minlength="1"
          />
        </div>
        <div class="input-container">
          <label>Nazwa do wyświetlania(Test opieka):</label>
          <input
            v-model="displayName"
            id="displayName"
            type="text"
            class="form-control"
            required
            minlength="1"
          />
        </div>

        <div class="input-container">
          <label>Minimalna cena:</label>
          <input
            v-model.number="minimum"
            id="minimum"
            class="form-control"
            type="text"
            required
            minlength="1"
          />
        </div>
      </div>
      <div class="multiple-inputs">
        <div class="input-container">
          <label>Pierwszy próg ceny:</label>
          <input
            v-model.number="firstThreshold"
            id="firstThreshold"
            class="form-control"
            type="text"
            required
            minlength="1"
          />
        </div>

        <div class="input-container">
          <label>Drugi próg ceny:</label>
          <input
            v-model.number="secondThreshold"
            id="secondThreshold"
            class="form-control"
            type="text"
            required
            minlength="1"
          />
        </div>
      </div>
      <div class="multiple-inputs">
        <div class="input-container">
          <label>Stawka MIN:</label>
          <input
            v-model.number="min"
            id="min"
            type="text"
            class="form-control"
            required
            minlength="1"
          />
        </div>
        <div class="input-container">
          <label>Stawka MAX:</label>
          <input
            v-model.number="max"
            id="max"
            type="text"
            class="form-control"
            required
            minlength="1"
          />
        </div>

        <!-- <div class="input-container">
          <label>Typ (ONCE albo HOURLY):</label>
          <input
            v-model="type"
            id="type"
            type="text"
            class="form-control"
            required
            minlength="1"
          />
        </div> -->
      </div>
      <div class="multiple-inputs">
        <div class="input-container">
          <label>Opis:</label>
          <html-editor
            @contentchanged="handleHtmlEditorContentForService($event)"
            :startContent="''"
          />
        </div>
        <div class="input-container">
          <label>Dodane godziny trwania usługi</label>
          <input
            min="0"
            max="10000"
            type="number"
            v-model="added_duration_hours"
            class="form-control"
          />
        </div>
      </div>
      <div class="multiple-inputs">
        <div class="input-container">
          <div>
            <span>Czy usługa wymaga PWZ?</span>
            <div>
              <input
                type="radio"
                id="radio_need_verification"
                v-model="need_verification"
                :value="true"
              />
              <label for="radio_need_verification">Tak</label>
              <br />
              <input
                type="radio"
                id="radio_not_need_verification"
                v-model="need_verification"
                :value="false"
              />
              <label for="radio_not_need_verification">Nie</label>
            </div>
          </div>
          <div>
            <span>Typ karnetu (wzorzec dni)</span>
            <div>
              <select v-model="customSelectDays">
                <option :value="null">Usługa bez karnetu dni</option>
                <option value="WEEKLY_WORKING_DAYS">
                  Karnet 5-dniowy (pon-pt)
                </option>
                <option value="WEEKLY_ALL_DAYS">
                  Karnet 7-dniowy (cały tydzień)
                </option>
                <option value="ONE_WORKING_DAY_ANY_CHOSEN">
                  1 dowolny dzień roboczy
                </option>
                <option value="THREE_WORKING_DAYS_ANY_CHOSEN">
                  3 dowolne dni robocze
                </option>
              </select>
            </div>
          </div>
          <div>
            <span>Odnawianie karnetu</span>
            <div>
              <select v-model="recurrenceType" :disabled="!customSelectDays">
                <option :value="null">Karnet jednorazowy</option>
                <option value="WEEKLY_WORKING_DAYS">
                  Odnawiany automatycznie co tydzień
                </option>
              </select>
            </div>
          </div>
          <div v-if="customSelectDays">
            <span>Dni tygodnia karnetu</span>
            <div class="carnet-weekdays">
              <label v-for="day in weekdayOptions" :key="day.value">
                <input
                  type="checkbox"
                  :value="day.value"
                  v-model="carnetWeekdays"
                />
                {{ day.label }}
              </label>
              <small>
                Zostaw puste, żeby użyć układu z typu karnetu. Zaznacz dni tylko
                wtedy, gdy usługa ma własny układ, np.
                poniedziałek/środa/piątek.
              </small>
            </div>
          </div>
          <div v-if="customSelectDays">
            <span>Liczba dni do wyboru</span>
            <div>
              <input
                type="number"
                min="1"
                max="7"
                v-model.number="carnetDaysToSelect"
                placeholder="domyślnie z typu karnetu"
              />
              <small class="form-hint">
                Ile dni z powyższego układu bierze klient. Równa liczbie dni =
                jedno kliknięcie bierze cały tydzień; mniejsza = klient sam
                wybiera dni.
              </small>
            </div>
          </div>
          <div v-if="customSelectDays">
            <span>Realizowany też w święta?</span>
            <div>
              <input
                type="radio"
                id="carnet_ignores_holidays"
                v-model="carnetIgnoresHolidays"
                :value="true"
              />
              <label for="carnet_ignores_holidays"
                >Tak - święta nie usuwają dni</label
              >
              <br />
              <input
                type="radio"
                id="carnet_respects_holidays"
                v-model="carnetIgnoresHolidays"
                :value="false"
              />
              <label for="carnet_respects_holidays"
                >Nie - święta usuwają dzień dostawy</label
              >
            </div>
          </div>
          <div v-if="customSelectDays">
            <span>Obsługa weekendów</span>
            <div>
              <label>
                <input
                  type="checkbox"
                  id="carnet_weekend_delivery"
                  v-model="carnetWeekendDelivery"
                />
                Sobota i niedziela mają własne dostawy
              </label>
              <small>
                Dotyczy tylko raportu Glovo. Niezaznaczone: obiady z soboty i
                niedzieli jadą z ostatnią dostawą roboczą przed weekendem (np.
                czw/pt/sb = czwartek 1 zestaw, piątek 2 zestawy). Zaznaczone:
                każdy wybrany dzień, także weekendowy, ma osobny wiersz z 1
                zestawem.
              </small>
            </div>
          </div>
          <div v-if="customSelectDays">
            <span>Kod dla kuriera (raport Glovo)</span>
            <div>
              <input
                type="text"
                maxlength="8"
                v-model="glovoCodePrefix"
                placeholder="prefiks diety, np. T"
              />
              <input
                type="number"
                min="1"
                max="20"
                v-model.number="glovoSetsPerDay"
                placeholder="zestawów na dzień"
              />
              <small class="form-hint">
                Kod składa się z prefiksu i liczby zestawów w paczce, np. T + 1
                zestaw daje T1 na co dzień i T3 dla piątkowej paczki
                weekendowej. Puste oba pola = w raporcie pojawi się nazwa
                usługi.
              </small>
            </div>
          </div>
          <div>
            <span>Zamawianie możliwe od (opcjonalnie)</span>
            <div>
              <input type="date" v-model="orderableFrom" />
              <small class="form-hint">
                Klient nie wybierze w kalendarzu dnia wcześniejszego niż ta
                data. Puste = bez ograniczenia. Zamówienia składane z panelu
                admina nie podlegają blokadzie.
              </small>
            </div>
          </div>
          <div>
            <span>Tylko dla kont biznesowych?</span>
            <div>
              <input
                type="radio"
                id="only_for_business"
                v-model="company_service"
                :value="true"
              />
              <label for="radio_company_service">Tak</label>
              <br />
              <input
                type="radio"
                id="not_only_for_business"
                v-model="company_service"
                :value="false"
              />
              <label for="radio_company_service">Nie</label>
            </div>
          </div>
          <div>
            <span>Świadczona stacjonarnie?</span>
            <div>
              <input
                type="radio"
                id="only_stationary"
                v-model="only_stationary"
                :value="true"
              />
              <label for="radio_stationary">Tak</label>
              <br />
              <input
                type="radio"
                id="not_only_stationary"
                v-model="only_stationary"
                :value="false"
              />
              <label for="radio_stationary">Nie</label>
            </div>
          </div>
          <div>
            <span
              >Zablokowana możliwość użycia kuponów promocyjnych do usług?</span
            >
            <div>
              <input
                type="radio"
                id="blocked_codes_yes"
                v-model="promotionCodesBlocked"
                :value="true"
                name="blocked_codes_yes"
              />
              <label for="blocked_codes_yes">Tak</label>
              <br />
              <input
                type="radio"
                id="blocked_codes_no"
                v-model="promotionCodesBlocked"
                :value="false"
                name="blocked_codes_no"
              />
              <label for="blocked_codes_no">Nie</label>
            </div>
          </div>
          <div>
            <span>Usługa wymaga rejestracji / logowania?</span>
            <div>
              <input
                type="radio"
                id="needRegisterYes"
                v-model="needRegister"
                :value="true"
                name="needRegisterYes"
              />
              <label for="needRegisterYes">Tak</label>
              <br />
              <input
                type="radio"
                id="needRegisterNo"
                v-model="needRegister"
                :value="false"
                name="needRegisterNo"
              />
              <label for="needRegisterNo">Nie</label>
            </div>
          </div>
        </div>
      </div>
      <services-checkboxes
        :title="`Checkboxy do zaakceptowania`"
        @checkboxesUpdated="handleNewServiceRegulations"
      />

      <services-checkboxes
        :title="`Checkboxy przy dodawaniu uslugi`"
        @checkboxesUpdated="handleNewServiceRegulationsWhenAdding"
      />

      <button
        v-if="serviceCategory"
        class="buttonm btn btn-outline-dark"
        type="submit"
      >
        Dodaj
      </button>
    </form>
    <p v-if="serviceResponse.message" class="text-danger">
      {{ serviceResponse.message }}
    </p>
  </div>
</template>

<script>
import axios from "../../axios";
import HtmlEditor from "../../components/HtmlEditor.vue";
import ServicesCheckboxes from "../../components/ServicesCheckboxes.vue";
export default {
  components: { HtmlEditor, ServicesCheckboxes },
  name: "create-service",
  created() {
    this.$store.dispatch("fetchServiceCategoriesTypes");
    this.$store.dispatch("fetchServiceCategoriesWithServices");
  },
  watch: {
    serviceCategory() {
      if (this.serviceCategory) {
        this.subCategory = null;
        const url = `api/subCategory/${this.serviceCategory}`;
        axios
          .get(url)
          .then((response) => {
            this.subCategories = response.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  computed: {
    serviceResponse() {
      return this.$store.getters.getAddedServiceMessage;
    },
    serviceCategoriesWithServices() {
      return this.$store.getters.getServiceCategoryWithServices;
    },
    serviceCategoriesTypes() {
      return this.$store.getters.getServiceCategoriesTypes;
    },
  },

  data: function () {
    return {
      name: "",
      displayName: "",
      minimum: "",
      firstThreshold: "",
      secondThreshold: "",
      multiplier: "",
      min: "",
      max: "",
      type: "",
      priceFor: "",
      serviceCategory: null,
      serviceType: null,
      newCategory: null,
      newCategoryDisplayName: null,
      newCategoryDescription: null,
      need_verification: false,
      company_service: false,
      only_stationary: false,
      subCategories: [],
      subCategory: null,
      addingNewCategory: false,
      customSelectDays: null,
      recurrenceType: null,
      carnetWeekdays: [],
      carnetDaysToSelect: null,
      carnetIgnoresHolidays: false,
      orderableFrom: "",
      carnetWeekendDelivery: false,
      glovoCodePrefix: null,
      glovoSetsPerDay: null,
      weekdayOptions: [
        { value: 1, label: "Pn" },
        { value: 2, label: "Wt" },
        { value: 3, label: "Śr" },
        { value: 4, label: "Cz" },
        { value: 5, label: "Pt" },
        { value: 6, label: "Sb" },
        { value: 7, label: "Nd" },
      ],
      newServiceRegulations: [],
      newServiceRegulationsWhenAdding: [],
      added_duration_hours: "",
      promotionCodesBlocked: false,
      needRegister: true,
    };
  },
  methods: {
    handleNewServiceRegulations(regulations) {
      this.newServiceRegulations = regulations;
    },
    handleNewServiceRegulationsWhenAdding(regulations) {
      this.newServiceRegulationsWhenAdding = regulations;
    },

    handleHtmlEditorContentForService(content) {
      this.priceFor = content;
    },
    handleHtmlEditorContentForCategory(content) {
      this.newCategoryDescription = content;
    },
    addNewCategory() {
      const type = this.serviceType;
      const name = this.newCategory;
      const newCategoryDisplayName = this.newCategoryDisplayName;
      const description = this.newCategoryDescription;
      const url = `api/serviceCategory`;

      const tmp = document.createElement("DIV");
      tmp.innerHTML = description;
      const textWithoutHTMLMarks = tmp.textContent || tmp.innerText || "";
      if (textWithoutHTMLMarks && textWithoutHTMLMarks.length > 2048) {
        this.$notify({
          group: "error",
          text: `Zbyt długi opis kategorii. Maksymalna długość to 2048 znaków. Twój opis zawiera ${textWithoutHTMLMarks.length} znaków`,
        });
        return;
      }
      let formatted = description
        ? description.replaceAll("<li>", "<li><span>")
        : "";
      formatted = formatted.replaceAll("</li>", "</span></li>");

      axios
        .post(url, {
          type: type,
          name: name,
          display_name: newCategoryDisplayName,
          description: formatted,
        })
        .then((response) => {
          this.serviceCategory = response.data.id;
          this.$store.dispatch("fetchServiceCategoriesWithServices");
          this.newCategory = null;
          this.serviceType = "";
          (this.newCategoryDisplayName = null),
            (this.newCategoryDescription = null);
          this.only_stationary = false;
          this.company_service = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleServiceCreate(e) {
      e.preventDefault();
      const confirmed = confirm("Czy na pewno chcesz dodać usługę?");
      if (!confirmed) {
        return;
      }

      this.$store
        .dispatch("addService", {
          name: this.name,
          displayName: this.displayName,
          minimum: this.minimum,
          min: this.min,
          max: this.max,
          firstThreshold: this.firstThreshold,
          secondThreshold: this.secondThreshold,
          multiplier: this.multiplier,
          type: this.type,
          price_for: this.priceFor,
          service_category_id: this.serviceCategory,
          need_verification: this.need_verification,
          company_service: this.company_service,
          only_stationary: this.only_stationary,
          sub_category_id: this.subCategory,
          regulations: this.newServiceRegulations,
          regulationsWhenAdding: this.newServiceRegulationsWhenAdding,
          added_duration_hours: this.added_duration_hours,
          promotion_codes_blocked: this.promotionCodesBlocked,
          is_public: !this.needRegister,
          custom_select_days: this.customSelectDays,
          recurrence_type: this.recurrenceType,
          carnet_weekdays: this.carnetWeekdays,
          carnet_days_to_select: this.carnetDaysToSelect,
          carnet_ignores_holidays: this.carnetIgnoresHolidays,
          orderable_from: this.orderableFrom,
          carnet_weekend_delivery: this.carnetWeekendDelivery,
          glovo_code_prefix: this.glovoCodePrefix,
          glovo_sets_per_day: this.glovoSetsPerDay,
        })
        .then(() => {
          // if (!this.serviceResponse.error) {
          //   this.name = "";
          //   this.displayName = "";
          //   this.minimum = "";
          //   this.firstThreshold = "";
          //   this.secondThreshold = "";
          //   this.multiplier = "";
          //   this.min = "";
          //   this.max = "";
          //   this.type = "";
          //   this.price_for = "";
          //   this.need_verification = false;
          //   (this.serviceCategory = null),
          //     (this.newCategoryDisplayName = null),
          //     (this.newCategory = null);
          //   this.subCategory = null;
          //   this.subCategories = [];
          // }
        });
    },
  },
};
</script>

<style scoped>
div.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
button.btn {
  margin-top: 20px;
}
div.input-container {
  flex-direction: column;
  display: flex;
  margin-top: 10px;
}
.multiple-inputs {
  display: flex;
  align-items: center;
}
.input-container {
  font-size: 15px;
}
.input-container label {
  font-size: 15px;
}

.main-container {
  margin: 0 auto;
  max-width: 1000px;
}

.main-container .form-control {
  max-width: 300px;
}
.newCategoryForm {
  margin-bottom: 50px;
}
.newCategoryForm div input,
.newCategoryForm div textarea,
.form-control,
.newCategoryForm button {
  width: 300px;
  margin: 0;
}
.topform {
  width: 100%;
  margin-top: 5rem;
}
#added_duration_hours {
  width: 320px;
  margin-top: 50px;
}
.carnet-weekdays label {
  display: inline-block;
  margin-right: 12px;
  white-space: nowrap;
}
.carnet-weekdays small,
.form-hint {
  display: block;
  max-width: 300px;
  margin-top: 4px;
  color: #6b6b6b;
  line-height: 1.3;
}
</style>
